import ProyectView from "./ProyectView";

export default ProyectView;
